import PropTypes from 'prop-types';
import React from 'react';
import { MobileModal } from '../';
import AgendaView from './AgendaView';
import DayView from './DayView';
import { Button, Header, Modal } from 'semantic-ui-react';
import styles from './AvailabilityChecker.scss';

export default class AvailabilityDetails extends React.Component {
  static propTypes = {
    eventsOnDay: PropTypes.array,
    selectedDay: PropTypes.object.isRequired,
    updateSelectedDay: PropTypes.func.isRequired,
    close: PropTypes.func,
    closeAvailabilityChecker: PropTypes.func,
    isOpen: PropTypes.bool,
    viewer: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      view: 'dayView'
    };
    this.setView = this.setView.bind(this);
  }

  setView(view) {
    this.setState({ view });
  }

  render() {
    const {
      close,
      closeAvailabilityChecker,
      eventsOnDay,
      isOpen,
      selectedDay,
      updateSelectedDay,
      viewer
    } = this.props;
    const { view } = this.state;
    const selectedView =
      view === 'agenda'
        ? <AgendaView
          selectedDay={selectedDay}
          eventsOnDay={eventsOnDay}
          close={close}
          closeAvailabilityChecker={closeAvailabilityChecker}
          timeZone={viewer.s_time_zone}
        />
        : <DayView
          events={eventsOnDay}
          selectedDay={selectedDay}
          updateSelectedDay={updateSelectedDay}
          close={close}
          closeAvailabilityChecker={closeAvailabilityChecker}
          timeZone={viewer.s_time_zone}
        />;
    const availabilityInfo = (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Button.Group basic size='small'>
          <Button
            active={view === 'dayView'}
            onClick={this.setView.bind(this, 'dayView')}
          >
            Day
          </Button>
          <Button
            onClick={this.setView.bind(this, 'agenda')}
            active={view === 'agenda'}
          >
            Agenda
          </Button>
        </Button.Group>
        {selectedView}
      </div>
    );

    return (
      <div style={{ display: 'inline-block' }}>
        <Modal
          open={isOpen}
          onClose={close}
          closeIcon
          size='small'
          className={styles.availabilityDetailsDesktop}
          mountNode={document.getElementById('desktopModal')}
        >
          <Modal.Content style={{ maxHeight: '100%', overflowY: 'scroll' }}>
            {availabilityInfo}
          </Modal.Content>
        </Modal>
        <MobileModal
          open={isOpen}
          onClose={close}
          mountNode={document.getElementById('mobileModal')}
        >
          <MobileModal.Header>
            <div className='menu'>
              <a className='item' onClick={close}>
                <i className='chevron left icon' />
              </a>
            </div>
          </MobileModal.Header>
          <MobileModal.Content>
            {availabilityInfo}
          </MobileModal.Content>
        </MobileModal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Modules/AvailabilityChecker/AvailabilityDetails.js